import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { UsuarioModalComponent } from '../../../shared/components/usuario-modal/usuario-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) { }

  openUsuarioModal(data: any): void {
    if (this.overlayRef) {
      this.closeModal();
    }

    const positionStrategy = this.overlay.position()
      .global()
      .centerHorizontally()
      .centerVertically();

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      panelClass: 'custom-modal-panel',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),

    });

    const modalPortal = new ComponentPortal(UsuarioModalComponent);
    const componentRef = this.overlayRef.attach(modalPortal);

    // Pasar datos al componente
    componentRef.instance.usuario = data.usuario;
    componentRef.instance.heading = data.heading;
    componentRef.instance.button = data.button;
    componentRef.instance.classButton = data.classButton;

    // Escuchar eventos
    componentRef.instance.usuarioSaved.subscribe((usuario) => {
      data.onSave(usuario);
      this.closeModal();
    });

    componentRef.instance.modalClosed.subscribe(() => {
      this.closeModal();
    });

    // Cerrar al hacer clic en el fondo gris
    this.overlayRef.backdropClick().subscribe(() => {
      this.closeModal();
    });
  }

  closeModal(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
